import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-oracle',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Oracle icon</title><path d="M16.412 4.412h-8.82a7.588 7.588 0 0 0-.008 15.176h8.828a7.588 7.588 0 0 0 0-15.176zm-.193 12.502H7.786a4.915 4.915 0 0 1 0-9.828h8.433a4.914 4.914 0 1 1 0 9.828z"/></svg>`,
    styles: []
})
export class SimpleIconsOracleComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#F80000';
    @Input() className: string = 'simple-icons-oracle'
    constructor() {}
    ngOnInit(): void {}
}
